








import { Component, Vue, Prop } from "vue-property-decorator";
import { User } from "@/models/user";

@Component({ name: "UserBasic" })
export default class UserBasic extends Vue {
  @Prop() readonly user!: User;
  @Prop({ required: false,default: "" }) readonly badge!: string;

  get fullName() {
      return this.user.first_name + ' ' + this.user.last_name
  }

  get initials() {
      return this.user.first_name.charAt(0) + this.user.last_name.charAt(0)
  }
}
